<template>
  <div class="account-table border-bg">
    <div class="table-filter">
      <div class="table-action">
        <el-button class="pl-btn" @click="showPlBox = true"> <svg-icon iconClass="pl" className="plIcon"></svg-icon>批量操作</el-button>
        <span class="piliang border-bg" v-show="showPlBox">
          <span class="batch-span"
            >已选择<a>{{ selectOption.length }}</a
            >账户</span
          >
          <div class="icon-list">
            <el-tooltip content="开启同步" placement="top">
              <svg-icon iconClass="start" className="batch-icon" @click="editStatusMul(1)"></svg-icon>
            </el-tooltip>
            <el-tooltip content="关闭同步" placement="top">
              <svg-icon iconClass="stop" className="batch-icon" @click="editStatusMul(0)"></svg-icon>
            </el-tooltip>
            <!-- <el-tooltip content="分配" placement="top">
              <svg-icon
                iconClass="distribute"
                className="batch-icon"
                @click="mulDistribution"
              ></svg-icon>
            </el-tooltip> -->
            <span class="close-icon">
              <svg-icon iconClass="close" className="close-btn" @click="showPlBox = false"></svg-icon>
            </span>
          </div>
        </span>
      </div>
    </div>
    <div>
      <el-table :data="tableData" @selection-change="handleSelectionChange" ref="account" height="calc(100vh - 285px)" style="width: 100%">
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column prop="synStatus" width="100" label="同步状态">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.synStatus"
              active-color="#1890ff"
              inactive-color="rgba(0, 0, 0, 0.25)"
              :active-value="1"
              :inactive-value="0"
              @change="(e) => changeSingleStatus(e, scope.row)"
            >
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="advertiserId" label="账户ID"> </el-table-column>
        <el-table-column prop="advertiserName" label="广告账户名称"> </el-table-column>
        <el-table-column prop="company" label="公司主体"> </el-table-column>
        <el-table-column prop="permissionStatus" label="授权状态">
          <template slot-scope="scope">
            <div>
              <span v-if="scope.row.permissionStatus == 1">
                <i class="el-icon-check" style="color: rgba(30, 194, 56, 1); cursor: pointer"></i>
                成功
              </span>
              <span v-if="scope.row.permissionStatus == 0">
                <el-tooltip class="item" effect="dark" content="刷新token失败，请重新授权" placement="top">
                  <i class="el-icon-warning-outline" style="color: rgba(234, 49, 49, 1)"></i>
                </el-tooltip>
                失败
              </span>
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="productName" label="所属产品">
          <template slot-scope="scope">
            <div class="distribution-wrap">
              <span
                :style="{
                  display: scope.row.productName ? 'none' : 'inline-block',
                }"
                class="dots"
              ></span>
              <span>{{
                scope.row.productName ? scope.row.productName : "未分配"
              }}</span>
              <span
                v-if="!scope.row.productName"
                class="distribute"
                @click="singleDistribution(scope.row.id)"
                >分配</span
              >
            </div>
          </template>
        </el-table-column> -->
        <!-- <el-table-column prop="department" label="所属部门" >
        </el-table-column> -->
        <el-table-column prop="source" label="来源"> </el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button type="text" size="small" slot="reference" @click="deleteOption(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分配弹框 -->
    <el-dialog title="分配产品" :visible.sync="showProDialog" width="394px" :close-on-click-modal="false">
      <div class="modal-wrap" style="display: flex; align-items: center">
        <span style="white-space: nowrap">选择产品：</span>
        <el-select v-model="selectProduct" placeholder="请选择" style="width: 100%">
          <el-option v-for="item of productList" :key="item.id" :label="item.appName" :value="item.id"></el-option>
        </el-select>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showProDialog = false">取 消</el-button>
        <el-button type="primary" @click="distributionProduct">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { column } from "../config";
import SvgIcon from "@/components/SvgIcon.vue";
import launchServer from "@/api/account-management";
export default {
  data() {
    return {
      column: column,
      selectOption: [],
      total: 0,
      productList: [],
      showProDialog: false,
      selectProduct: null,
      curId: null, //当前分配的账号,通过该字段判断是是否为批量
      showPlBox: false,
    };
  },
  props: {
    tableData: Array,
  },
  components: { SvgIcon },
  mounted() {
    this.getFilterSelectList();
  },
  methods: {
    handleSelectionChange(e) {
      if (e.length > 0) {
        this.showPlBox = true;
      } else {
        this.showPlBox = false;
      }
      this.selectOption = e;
    },
    deleteOption(rowData) {
      let htmlStr = `
      <div class="tip-content" style="font-size:14px;color:rgba(0, 0, 0, 0.65)">
        <p style="margin-bottom:8px">删除后</p>
        <p style="margin-bottom:8px">1、系统中将无法看到该账户的广告、创意、数据等信息</p>
        <p style="margin-bottom:8px">2、已删除账户暂不支持重新授权，如需重新授权需联系运营处理</p>
      </div>
      `;
      this.$confirm(htmlStr, "确认要删除" + rowData.advertiserName + "？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
        dangerouslyUseHTMLString: true,
      })
        .then(() => {
          launchServer.deleteAdvertiserInfo({ id: rowData.id }).then((res) => {
            if (res.code === "0000") {
              this.$message({
                message: "账号删除成功",
                type: "success",
              });
              this.$emit("refrushList");
            }
          });
          this.$refs.account.clearSelection();
        })
        .catch(() => {});
    },
    getFilterSelectList() {
      launchServer.getProducts().then((res) => {
        if (res.code === "0000") {
          this.productList = res.productList;
        }
      });
    },
    distributionProduct() {
      if (!this.selectProduct) {
        this.$message({
          message: "请选择一个产品",
          type: "warning",
        });
        return;
      } else {
        let parmas = {
          productId: this.selectProduct,
        };
        if (this.curId) {
          //单项分配
          parmas.id = this.curId;
        } else {
          //批量分配
          parmas.id = this.selectOption.map((item) => item.id).join();
        }
        launchServer.modifyAdvertiserInfo(parmas).then((res) => {
          if (res.code === "0000") {
            this.$message({
              message: "账号分配成功",
              type: "success",
            });
            this.$emit("refrushList");
            this.showProDialog = false;
          }
        });
      }
    },
    changeSingleStatus(e, data) {
      launchServer
        .modifyAdvertiserInfo({
          id: data.id,
          synStatus: e,
        })
        .then((res) => {
          if (res.code === "0000") {
            this.$message({
              message: "同步状态修改成功",
              type: "success",
            });
          }
        });
    },
    singleDistribution(id) {
      this.curId = id;
      this.showProDialog = true;
    },
    //批量修改
    mulDistribution() {
      if (this.selectOption.length === 0) {
        this.$message({
          message: "请至少选择一条数据",
          type: "warning",
        });
        return;
      }
      this.curId = null;
      this.showProDialog = true;
    },
    editStatusMul(synStatus) {
      if (this.selectOption.length === 0) {
        this.$message({
          message: "请至少选择一条数据",
          type: "warning",
        });
        return;
      }
      launchServer
        .modifyAdvertiserInfo({
          id: this.selectOption.map((item) => item.id).join(),
          synStatus,
        })
        .then((res) => {
          if (res.code === "0000") {
            this.$message({
              message: "同步状态修改成功",
              type: "success",
            });
            this.$emit("refrushList");
          }
        });
    },
  },
};
</script>
<style lang="less" scoped>
.distribution-wrap {
  display: flex;
  align-items: center;
  .dots {
    display: inline-block;
    width: 6px;
    height: 6px;
    background: rgba(235, 49, 49, 1);
    border-radius: 50%;
    margin-right: 8px;
  }
}
.distribute {
  display: none;
}
.el-table__row:hover {
  .distribute {
    display: inline-block;
    margin-left: 8px;
    font-size: 13px;
    color: rgba(24, 144, 255, 1);
    cursor: pointer;
  }
}
.account-table {
  margin: 0 16px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
  padding: 0 24px 24px;
  box-sizing: border-box;
  .table-filter {
    display: flex;
    justify-content: space-between;
    .table-action {
      display: flex;
      align-items: center;
      padding: 9px 0px;
      width: 100%;
      height: 45px;
      .pl-btn {
        .plIcon {
          margin-right: 4px;
        }
        border: 1px solid #1890ff;
        color: #1890ff;
      }
    }
  }
}
.piliang {
  height: 45px;
  line-height: 45px;
  padding-left: 12px;
  margin-left: 12px;
  display: flex;
  justify-content: space-between;
  .batch-span {
    font-size: 13px;
    color: rgba(0, 0, 0, 1);
    a {
      color: rgba(24, 144, 255, 1);
      margin: 0 5px;
    }
  }
  .icon-list {
    margin-left: 58px;
    color: rgba(24, 144, 255, 1);
  }
  .batch-icon {
    margin-right: 26px;
    cursor: pointer;
  }
  .close-btn {
    color: rgba(0, 0, 0, 0.6);
    font-size: 12px;
    margin: 0 16px 0 40px;
    cursor: pointer;
  }
}
</style>
